import { Container, Row, Col, Table } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function ParticipantTravel() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Participant info"
        title="Travel"
        intro="Ljubljana is easily accessible by train, bus, plane and car. The main railway and bus stations are located close to the city centre."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className="h1">Travel to Ljubljana</h2>
                <p>
                  Ljubljana is well connected with neighbouring countries and can be reached by <span class="text-marker">train, bus, plane,
                  shuttle service or car.</span> The main railway and bus stations are located in the city centre.
                </p>
              </section>

              <section className="info-section">
                <div className="d-flex gap-3 mb-3">
                <div className="thing-card-icon">
                  <i className="bi bi-train-front" aria-hidden="true"></i>
                </div>
                <h2 className="mb-0">By Train or Bus</h2>
              </div>

                <p>
                  Ljubljana has good international rail connections, especially from neighbouring countries.
                </p>

                <p>
                  Direct trains are available from Vienna (~6 h), Graz (~3:45 h), Klagenfurt, Zagreb (~2:30 h),
                  and convenient connections via Trieste or Villach typically take around 3–4 hours.
                </p>

                <p>
                  All international trains and buses arrive at <span class="text-marker">Ljubljana Railway Station / Ljubljana Bus Station</span>
                  (Železniška postaja / Avtobusna postaja / AP ŽP) in the city centre.
                </p>

                <div className="info-note">
                  <p>
                    <strong>Map:</strong> TBA.
                  </p>
                </div>
              </section>

              <section className="info-section">
               <div className="d-flex gap-3 mb-3">
                <div className="thing-card-icon">
                  <i className="bi bi-airplane" aria-hidden="true"></i>
                </div>
                <h2 className="mb-0">By Plane</h2>
              </div>

                <p>
                  Ljubljana has its own airport, but we recommend checking connections to other airports in the vicinity
                  as well:
                </p>

                <ul className="info-list">
                  <li><span class="text-marker">Ljubljana Airport (LJU), Ljubljana Jože Pučnik Airport</span></li>
                  <li>Zagreb Airport (ZAG)</li>
                  <li>Venice Marco Polo Airport (VCE)</li>
                  <li>
                    Smaller airports include Trieste Airport (TRS), Venice Treviso Airport (TSF) and Klagenfurt (KLU).
                  </li>
                </ul>

            
                <h3 className="mb-0 mt-5">Travelling from Airports to Ljubljana City</h3>

                <div className="table-responsive">
                  <Table hover className="info-table mb-0">
                    <thead>
                      <tr>
                        <th>Airport</th>
                        <th>Typical duration to Ljubljana</th>
                        <th>Recommended options</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Ljubljana (LJU)</td>
                        <td>0:30–0:50</td>
                        <td>Bus (30–50 min); shuttle/taxi (20–30 min)</td>
                      </tr>
                      <tr>
                        <td>Zagreb (ZAG)</td>
                        <td>2:00–3:30</td>
                        <td>Direct bus/shuttle (~2–3 h)</td>
                      </tr>
                      <tr>
                        <td>Trieste (TRS)</td>
                        <td>1:45–3:15</td>
                        <td>Shuttle or bus via Trieste</td>
                      </tr>
                      <tr>
                        <td>Venice (VCE/TSF)</td>
                        <td>2:45–3:30</td>
                        <td>Direct bus/shuttle</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                

                <h4 className='mt-4'>Shuttle service</h4>

                <p>
                  The most convenient way to reach Ljubljana city from the airports is to use <span class="text-marker">shuttle services</span>:
                </p>

                <ul className="info-list">
                  <li>GoOpti — LJU from approximately 14 €.</li>
                  <li>NomaGo — LJU from approximately 14 €.</li>
                  <li>TripstAir — VCE from approximately 28 €, from/to Venice.</li>
                </ul>

                <p className='mt-3'>
                  <strong>Route:</strong> Sequential door-to-door service optimised by the driver.
                  <br />
                  <strong>Luggage:</strong> Usually unlimited capacity and declaration at booking.
                  <br />
                  <strong>Pick-up:</strong> Book for 1 hour after landing.
                  <br />
                  <strong>Drop-off:</strong> Schedule arrival at the airport 2 hours before take-off.
                </p>

                <h4>Bus</h4>

                <p>
                  <strong>Ljubljana Airport:</strong> Arriva bus (~4 €) drives to/from the main Railway Station. The
                  ticket can be purchased directly from the driver, preferably by card, or at the dedicated ticket
                  machine located at the bus stop.
                </p>

                <p>
                  <strong>Other airports:</strong> FlixBus options are available. Check whether the bus departs from
                  the airport or from the city’s central station.
                </p>

                <h4>Train</h4>

                <p>
                  There is no train connection with Ljubljana Airport. For other airports, you need to go to the
                  city’s central station.
                </p>

                <h4>Taxi</h4>

                <p>
                  A taxi from Ljubljana Airport typically costs around 40–80 €. We strongly recommend ordering your taxi
                  in advance to secure lower-rate prices at around 40 €.
                </p>

                <ul className="info-list">
                  <li> <a href="https://play.google.com/store/apps/details?id=com.ubercab&hl=en" target="_blank" rel="noreferrer">
                    Uber</a> in partnership with licensed local drivers</li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.metrotaxi" target="_blank" rel="noreferrer">
                    Metro Taxi</a></li>
                  <li>Ljubljana <a href="https://ljubljana-airport.taxi/" target="_blank" rel="noreferrer">
                    Airport Taxi</a></li>
                </ul>
              </section>

               <section className="info-section">
                <div className="d-flex gap-3 mb-3">
                <div className="thing-card-icon">
                  <i className="bi bi-car-front" aria-hidden="true"></i>
                </div>
                <h2 className="mb-0">By Car</h2>
              </div>

                <p>
                  Ljubljana is easily accessible by motorway from Austria, Italy, Croatia and Hungary. A Slovenian
                  <span class="text-marker">motorway vignette</span> is required. The vignette is available at petrol stations near the border, in
                  Slovenia and neighbouring countries, and online at <a href="https://evinjeta.dars.si" target="_blank" rel="noreferrer"> evinjeta.dars.si
                  </a>. A weekly vignette for cars costs approximately 16 €.
                </p>

                <p className="info-note">
                  <strong>Tip:</strong> Ljubljana has recently updated its parking policy, resulting in increased rates and expanded
                  payment hours across the city. Leaving your car at your hotel is recommended.
                </p>
              </section>

             
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}